import { render, staticRenderFns } from "./JgpGrid.vue?vue&type=template&id=4b3533b8&"
import script from "./JgpGrid.vue?vue&type=script&lang=js&"
export * from "./JgpGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports